import { render, staticRenderFns } from "./AdminPermissionForm.vue?vue&type=template&id=351e1292"
import script from "./AdminPermissionForm.vue?vue&type=script&lang=ts"
export * from "./AdminPermissionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports